import { isBrowser } from '../is-browser';
import { isEditing } from '../is-editing';
import { getUserAttributes } from '../track/helpers';
export const getFunctionArguments = ({ builder, context, event, state }) => {
    return Object.entries({
        state,
        Builder: builder,
        // legacy
        builder,
        context,
        event
    });
};
export const getBuilderGlobals = () => ({
    isEditing: isEditing(),
    isBrowser: isBrowser(),
    isServer: !isBrowser(),
    getUserAttributes: () => getUserAttributes()
});
export const parseCode = (code, { isExpression = true }) => {
    // Be able to handle simple expressions like "state.foo" or "1 + 1"
    // as well as full blocks like "var foo = "bar"; return foo"
    const useReturn = 
    // we disable this for cases where we definitely don't want a return
    isExpression && !(code.includes(';') || code.includes(' return ') || code.trim().startsWith('return '));
    const useCode = useReturn ? `return (${code});` : code;
    return useCode;
};
